var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93635 1.64604C4.9857 1.59948 5.04432 1.56253 5.10886 1.53733C5.1734 1.51212 5.2426 1.49915 5.31247 1.49915C5.38235 1.49915 5.45154 1.51212 5.51608 1.53733C5.58063 1.56253 5.63925 1.59948 5.6886 1.64604L12.0636 7.64604C12.1131 7.69248 12.1523 7.74766 12.1791 7.80841C12.2059 7.86915 12.2197 7.93427 12.2197 8.00004C12.2197 8.06581 12.2059 8.13093 12.1791 8.19167C12.1523 8.25242 12.1131 8.30759 12.0636 8.35404L5.6886 14.354C5.58884 14.4479 5.45355 14.5007 5.31247 14.5007C5.1714 14.5007 5.0361 14.4479 4.93635 14.354C4.83659 14.2602 4.78055 14.1328 4.78055 14C4.78055 13.8673 4.83659 13.7399 4.93635 13.646L10.9363 8.00004L4.93635 2.35404C4.88687 2.30759 4.84762 2.25242 4.82084 2.19167C4.79406 2.13093 4.78027 2.06581 4.78027 2.00004C4.78027 1.93427 4.79406 1.86915 4.82084 1.80841C4.84762 1.74766 4.88687 1.69249 4.93635 1.64604Z",
    fill: "#4BCAE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBlue);
export default __webpack_public_path__ + "static/media/next-blue.bce2f2cb187ac4d61ebf74b808d14cf2.svg";
export { ForwardRef as ReactComponent };